import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './style';

interface SocietyGuideRow {
	subject: string;
	date: string;
	placeLines: string[];
}

const SocietyGuide = () => {
	const { t } = useTranslation();
	const rows = t('society.guide.table.rows', { returnObjects: true }) as SocietyGuideRow[];

	return (
		<S.Container>
			<S.SocietyListContainer>
				<S.SocietyListTitle>{t('society.guide.title')}</S.SocietyListTitle>
				<S.TablePanel>
					<S.Table>
					<S.TableHeadCell className="center">{t('society.guide.table.headers.subject')}</S.TableHeadCell>
					<S.TableHeadCell className="center">{t('society.guide.table.headers.date')}</S.TableHeadCell>
					<S.TableHeadCell className="center">{t('society.guide.table.headers.place')}</S.TableHeadCell>

					{rows.map((row) => (
						<Fragment key={row.subject}>
							<S.TableCell className="point min-height center">{row.subject}</S.TableCell>
							<S.TableCell className="center">{row.date}</S.TableCell>
							<S.TableCell className="center contact-cell">
								{row.placeLines.map((line, index) => (
									<span key={`${row.subject}-line-${index}`}>{line}</span>
								))}
							</S.TableCell>
						</Fragment>
					))}
					</S.Table>
				</S.TablePanel>
			</S.SocietyListContainer>
		</S.Container>
	);
};
export default SocietyGuide;
